var React = require('react');

function TruckPickup (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 304a88 88 0 1 0 88 88 88 88 0 0 0-88-88zm288 0a88 88 0 1 0 88 88 88 88 0 0 0-88-88z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M624 288h-16v-64a32 32 0 0 0-32-32h-48L419.22 56a64 64 0 0 0-50-24H256a32 32 0 0 0-32 32v128H64a32 32 0 0 0-32 32v64H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h46.8a120.12 120.12 0 0 1 226.4 0h61.6a120.12 120.12 0 0 1 226.4 0H624a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-336-96V96h81.24L446 192z","className":"fa-primary","key":2})]);
}

TruckPickup.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = TruckPickup;

TruckPickup.default = TruckPickup;
